import {getColor} from "@/styles/ThemeConfig";

export const selectStyles = (size = 'regular') => ({
    singleValue: (base) => ({
        ...base,
        fontSize: '16px',
        paddingLeft:'25px',
    }),
    input: (styles, { isDisabled }) => ({
        ...styles,
        padding: '6px 10px',
        paddingLeft: '25px',
        fontSize: '16px',
    }),
    control: (styles, { isDisabled }) => ({
        ...styles,
        height: size === 'small' ? '40px' : '64px',
        borderRadius:' 0px',
        border:'none',
        backgroundColor:isDisabled ? getColor('grayLines') : 'rgba(255,255,255, 1)',
        padding:'0 20px',
        borderColor: 'rgba(236,236,236, 1)',
    }),
    placeholder: (styles, { data }) => ({
        ...styles,
        color: getColor('lightGreen'),
        fontSize: '20px',
        fontWeight: '400',
        fontStyle: 'normal',
        letterSpacing: '0px',
        textAlign: 'left',
        paddingLeft: '25px',
        paddingTop: '2px',
    }),
    menu: (styles) => ({
        ...styles,
        zIndex:3,
        marginTop:'1px',
        borderRadius: '0px',
        boxShadow: '0px 1px 15px rgba(30,30,30, 0.08)',
        backgroundColor: 'rgba(255,255,255, 1)',
        fontSize: '16px',
        overflow:'hidden',
    }),
    menuList: (styles) => ({
        ...styles,
        fontSize: '16px',
        zIndex:3,
        backgroundColor: "white",
        // marginRight:'2px',
        paddingTop: "0px",
        paddingBottom: "0px",
        "::-webkit-scrollbar": {
            display: "none",
        },
        ":hover": {
            background_color: 'rgba(243,140,43, 0.096973)',
        },
    }),
    option: (styles, { isSelected,isDisabled }) => ({
        ...styles,
        backgroundColor: `${isSelected ? "rgba(243,140,43, 0.2)" : isDisabled ? '#f7f7f7' : "transparent"}`,

        // color: `${isSelected ? "#171219" : "#8B888C"}!important`,
        color: `${isDisabled ? getColor('graySecondary') : "#171219 !important" }`,
        borderBottom:`1px solid ${getColor('grayLines')}`,

        ":hover:not(:active)": {
            color: "#171219 !important",
            backgroundColor: `rgba(243,140,43, 0.5)`,
        },

        ":active": {
            backgroundColor: getColor('orange') + '!important',
            color:'white!important',
        },
    }),
    multiValue: (styles, { data }) => {
        return {
            ...styles,
            marginTop:'18px',
            borderRadius: '0px',
            boxShadow: '0px 2px 25px rgba(95,27,0, 0.05)',
            backgroundColor: 'rgba(250,250,250, 1)',
            padding:'0 3px',
        };
    },
    multiValueRemove: (styles, { data }) => ({
        ...styles,
        backgroundColor: 'transparent',
        ':hover': {
        },
    }),

    valueContainer: (styles, { data }) => ({
        ...styles,
    }),

})

